import { render, staticRenderFns } from "./notReceive.vue?vue&type=template&id=50c61b7b&scoped=true&"
import script from "./notReceive.vue?vue&type=script&lang=js&"
export * from "./notReceive.vue?vue&type=script&lang=js&"
import style0 from "./notReceive.vue?vue&type=style&index=0&id=50c61b7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c61b7b",
  null
  
)

export default component.exports